import React, { useMemo } from 'react'
import * as styles from '../checkoutModal.module.scss'
import { SuccessViewProps, View } from '../actionsWorkflow.type'

export const SuccessView = ({
   itemCount = 1,
   view,
   connectionName,
   dueBackDate,
   isAdminCompanyUser,
}: SuccessViewProps) => {
   const successMsg = useMemo(() => {
      switch (view) {
         case View.Loan: {
            const dueBackMsg =
               dueBackDate !== ''
                  ? `and will be due back on ${dueBackDate}`
                  : ''
            return `Your ${itemCount} ${
               itemCount > 1 ? 'items were' : 'item was'
            } Loaned to ${connectionName} ${dueBackMsg}`
         }
         case View.Return: {
            return isAdminCompanyUser
               ? 'Your Return request has been completed.'
               : 'Your Return request has been sent. We will notify you once the request has been accepted.'
         }
         case View.Field_Transfer:
         case View.Warehouse_Transfer: {
            return isAdminCompanyUser
               ? 'Your Transfer request has been sent.'
               : 'Your Transfer is complete.'
         }
         case View.Borrow: {
            return 'Your Borrow request has been sent. We will notify you once the request has been accepted.'
         }
         case View.MakeAvailable:
         case View.MakeUnavailable: {
            return `Your ${itemCount} ${
               itemCount > 1 ? 'items were' : 'item was'
            } made ${
               view === View.MakeAvailable ? 'Available' : 'Unavailable'
            }.`
         }
         default:
            return `Your ${view} is complete.`
      }
   }, [view, itemCount, connectionName, dueBackDate, isAdminCompanyUser])

   return (
      <div className={styles.centeredViewWrapper}>
         <h2 className={styles.centeredViewHeading}>Nice!</h2>
         <p className={styles.centeredViewMessage}>{successMsg}</p>
      </div>
   )
}
